import { Types } from '../actionTypes';

const initialState = []


const EmployeeMessages = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_MESSAGES:
      {
       
        return state = action.payload.msgsData;
      }
    default:
      return state;
  }
}

export default EmployeeMessages;
